const skillsMap = {
    Frontend: [
      { name: 'React', icon: 'devicon-react-original colored' },
      { name: 'HTML5', icon: 'devicon-html5-plain colored' },
      { name: 'CSS3', icon: 'devicon-css3-plain colored' },
      { name: 'JavaScript', icon: 'devicon-javascript-plain colored' },
    ],
    Backend: [
      { name: 'Spring', icon: 'devicon-spring-plain colored' },
      { name: 'Java', icon: 'devicon-java-plain colored' },
      { name: 'Python', icon: 'devicon-python-plain colored' },
      { name: 'Redis', icon: 'devicon-redis-plain colored' },
    ],
    Cloud: [
      { name: 'AWS', icon: 'devicon-amazonwebservices-plain-wordmark colored' },
      { name: 'Google Cloud Console', icon: 'devicon-googlecloud-plain colored' },
    ],
    Tools: [
      { name: 'Git', icon: 'devicon-git-plain colored' },
      { name: 'GitHub', icon: 'devicon-github-original colored' },
      { name: 'VS Code', icon: 'devicon-vscode-plain colored' },
      { name: 'IntelliJ', icon: 'devicon-intellij-plain colored' },
      { name: 'Docker', icon: 'devicon-docker-plain colored' },
      { name: 'Jenkins', icon: 'devicon-jenkins-plain colored' },
    ],
    Databases: [
      { name: 'MySQL', icon: 'devicon-mysql-plain colored' },
      { name: 'PostgreSQL', icon: 'devicon-postgresql-plain colored' },
    ],
    Additional: [
      { name: 'JIRA', icon: 'devicon-jira-plain colored' },
      { name: 'FileZilla', icon: 'devicon-filezilla-plain colored' },
      { name: 'Adobe Photoshop', icon: 'devicon-photoshop-plain' },
      { name: 'SonarQube', icon: 'devicon-sonarqube-plain colored' },
    ],
  };

  export { skillsMap };